import React, { useEffect, useState, useContext } from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { BusinessContextProvider } from "context/BusinessContext";
import MainBusiness from "pages/MainBusiness";
import HomePage from "pages/Home/HomePage";
import ProfilePage from "pages/ProfilePage";
import UserProfile from "pages/UserProfile";
import Layout from "components/layout/Layout";
import Layout2 from "components/layout/Layout2";
import Layout4 from "components/layout/Layout4";
import WithPageTitle from "utils/WithPageTitle";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";

export default function Router() {
  const auth = useContext(AuthenticationContext);
  const params = useParams();
  const [itemss, setItemss] = useState([]);
  const [updater, setUpdater] = useState(false);
  let itemsPerPage;
  if (window.innerWidth < 576) {
    itemsPerPage = 4;
  }
  if (window.innerWidth >= 576 && window.innerWidth < 992) {
    itemsPerPage = 8;
  }
  // if (window.innerWidth >= 768 && window.innerWidth < 992) {
  //   itemsPerPage = 8;
  // }
  if (window.innerWidth >= 992 && window.innerWidth < 1400) {
    itemsPerPage = 12;
  }
  if (window.innerWidth >= 1400) {
    itemsPerPage = 20;
  }

  return (
    <>
      <BusinessContextProvider>
        <WithPageTitle />
        <Routes>
          {/*  صفحه اصلی تات کلاب */}
          <Route
            path="/"
            element={
              <Layout>
                <HomePage
                  itemss={itemss}
                  setItemss={setItemss}
                  setUpdater={setUpdater}
                  updater={updater}
                />
              </Layout>
            }
          />
          {/*  صفحه اصلی کسب و کار */}
          <Route
            path="/:shop_suffix"
            element={
              <Layout2>
                <MainBusiness itemsPerPage={itemsPerPage} />
              </Layout2>
            }
          />
          {/*  پروفایل فروشگاه */}
          <Route path="/profile/:shop_suffix" element={<ProfileComponent />} />
          {/*  پروفایل کاربر */}
          <Route
            path="/user-profile"
            element={
              <>
                {auth.isLogged ? (
                  <Layout>
                    <UserProfile />
                  </Layout>
                ) : (
                  <Navigate to="/" replace />
                )}
              </>
            }
          />
        </Routes>
      </BusinessContextProvider>
    </>
  );
}

function ProfileComponent() {
  const auth = useContext(AuthenticationContext);
  const params = useParams();

  console.log(params);

  if (
    auth.isLogged &&
    auth.userInfo.shopIds.find(
      (value) => value.shopSuffix == params.shop_suffix
    )
  ) {
    return (
      <Layout4>
        <ProfilePage />
      </Layout4>
    );
  }
  return <Navigate to="/" replace />;
}
